export interface StagedBlockDraft {
  draftKey: string;
  specimenId: string;
  previewNumber: string;
}

export type BlockTargetRef =
  | { kind: "existing"; blockId: string }
  | { kind: "staged"; draftKey: string };

export function blockTargetKey(
  specimenId: string,
  target: BlockTargetRef
): string {
  return target.kind === "existing"
    ? `${specimenId}::existing::${target.blockId}`
    : `${specimenId}::staged::${target.draftKey}`;
}

export function parseBlockTargetKey(value: string): BlockTargetRef | null {
  const parts = value.split("::");
  if (parts.length !== 3) return null;
  if (parts[1] === "existing" && parts[2]) {
    return { kind: "existing", blockId: parts[2] };
  }
  if (parts[1] === "staged" && parts[2]) {
    return { kind: "staged", draftKey: parts[2] };
  }
  return null;
}

export function getNextBlockPreviewNumber(
  existingNumbers: string[],
  stagedNumbers: string[] = []
): string {
  const maximum = Math.max(
    0,
    ...existingNumbers.map((value) => Number.parseInt(value, 10) || 0),
    ...stagedNumbers.map((value) => Number.parseInt(value, 10) || 0)
  );
  return String(maximum + 1);
}

export function renumberStagedBlockDrafts(
  stagedBlocks: StagedBlockDraft[],
  specimenId: string,
  existingNumbers: string[]
): StagedBlockDraft[] {
  let nextNumber = Number.parseInt(
    getNextBlockPreviewNumber(existingNumbers),
    10
  );
  return stagedBlocks.map((draft) => {
    if (draft.specimenId !== specimenId) return draft;
    const renumbered = { ...draft, previewNumber: String(nextNumber) };
    nextNumber += 1;
    return renumbered;
  });
}
